import * as deviceDetect from 'react-device-detect';
import blockedEmailsList from './blockedEmailsList';

export function getFileExtension(filename) {
	return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0].toLowerCase() : undefined;
}

export function gup(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	var regexS = "[\\?&]" + name + "=([^&#]*)";
	var regex = new RegExp(regexS);
	var results = regex.exec(url);
	return results == null ? null : results[1];
}

export function decodeUrlString(urlString) {
	const decodedString = urlString?.replace(/\+/g, ' ');
	return decodeURIComponent(decodedString)
}

export function checkFileType(filename) {
	var ext = getFileExtension(filename);
	switch (ext) {
		case "zip":
		case "rar":
		case "7z":
		case "tar":
		case "gz":
			return "icon-file-archive";
		case "xlsx":
		case "xls":
		case "xlsm":
		case "xlsb":
		case "xltx":
		case "xml":
		case "csv":
		case "numbers":
			return "icon-file-excel";
		case "odt":
		case "txt":
		case "doc":
		case "docx":
		case "pages":
			return "icon-file-word";
		case "js":
		case "php":
		case "c":
		case "py":
		case "rb":
		case "html":
		case "go":
		case "css":
		case "config":
			return "icon-file-code";
		case "riff":
		case "wav":
		case "bwf":
		case "ogg":
		case "aiff":
		case "caf":
		case "raw":
		case "mp3":
		case "wma":
			return "icon-file-audio";
		case "pdf":
			return "icon-file-pdf";
		case "bmp":
		case "tiff":
		case "gif":
		case "jpeg":
		case "png":
		case "jpg":
		case "ico":
			return "icon-file-image-o";
		case "avi":
		case "mov":
		case "mpg":
		case "mp4":
		case "mkv":
		case "divx":
			return "icon-file-video";
		case "pptx":
		case "pptm":
		case "ppt":
			return "icon-file-powerpoint";
		default:
			return "icon-file";
	}
}


export async function checkDeviceAndBrowser() {
	const browserIsBrave = (navigator.brave && await navigator.brave.isBrave()) || false

	if (deviceDetect.isIOS) {
		if (parseInt(deviceDetect.osVersion) >= 13) {
			return true
		} else return false
	}

	if ((deviceDetect.isSafari || deviceDetect.isChrome || deviceDetect.isFirefox || deviceDetect.isEdge ||
		deviceDetect.isOpera || deviceDetect.isChromium || deviceDetect.isAndroid || (deviceDetect.isIE && deviceDetect.browserVersion >= 10) || browserIsBrave))
		return true;

	else
		return false;
}

export const encodeFormData = (data) => {
	return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&')
}

export function headers(payload) {
	let a = {
		"Accept-Language": localStorage.getItem('i18nextLng')
	}
	if (!payload.formData) a = {...a, "Content-Type": "application/json"}
	return a
}

// Determine whether we're looking for a prod, dev, staging or local url : the Api version.
export function getApiUrl() {
	const host = window.location.host
	let resultUrl

	if (/localhost/.test(host) || /api.develop.lockself/.test(host))
		resultUrl = process.env.REACT_APP_API_DEV_URL
	else if (/api.staging.lockself/.test(host))
		resultUrl = process.env.REACT_APP_API_STAGING_URL
	else resultUrl = window.location.origin

	return resultUrl
}

export function isValidEmail(email) {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple regex pour valider l'email
	return emailRegex.test(email);
}

export function isEmailAllowed(email) {
	const domain = email.split('@')[1]; // Sépare l'email par '@' et récupère la partie après
	const domainWithoutTLD = domain.split('.')[0]; // Sépare le domaine par '.' pour isoler la première partie
	if(domainWithoutTLD === "mail" && domain === "mail.ru") return false // spécifique email
	return !blockedEmailsList.includes(domainWithoutTLD); // Retourne true si l'email n'est pas dans la liste
}
